import { useQuery } from "@tanstack/react-query"
import { RuleGroupType } from "react-querybuilder"

import { ExploreResponses } from "@costory/types/endpoints/explorer"

import { apiClient } from "@costory/front/lib/apiClient"

// Query function that returns data directly for use with QueryWrapper
export const useSuggestedAxesDataQuery = (whereClause: {
  whereClause?: RuleGroupType
}) => {
  return useQuery({
    queryKey: ["suggestedAxesData", whereClause],
    queryFn: async () => {
      const filters = whereClause.whereClause

      if (!filters?.rules?.length) return []

      const response = await apiClient.post<ExploreResponses.SuggestedAxis[]>(
        "/explore/suggestedAxes",
        { whereClause: filters },
      )
      return response.data
    },
    enabled: true, // Always enable the query
  })
}
